import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { DatenschutzComponent } from './datenschutz/datenschutz.component';
 
import { MethodenComponent } from './methoden/methoden.component';
import { LeistungsangebotComponent } from './leistungsangebot/leistungsangebot.component';
import { KonzeptComponent } from './konzept/konzept.component';

const routes: Routes = [
  { path: '', component: LandingpageComponent, pathMatch: 'full' },
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  { path: 'methoden', component: MethodenComponent },
  { path: 'impressum', component: ImpressumComponent },
  { path: 'leistungsangebot', component: LeistungsangebotComponent },
  { path: 'konzept', component: KonzeptComponent },
  { path: 'conzept', component: KonzeptComponent },
  { path: 'datenschutz', component: DatenschutzComponent },
]


@NgModule({
  
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
  
})
export class AppRoutingModule { }
